if (!customElements.get("m-testimonials")) {
  class MTestimonials extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      let containerType, autoplay;
      let totalSlides = parseInt(this.dataset.total || "0", 10);
      if (this.dataset.design) {
        this.design = this.dataset.design;
      }
      if (this.dataset.container) {
        containerType = this.dataset.container;
      }
      if (this.dataset.autoplay) {
        autoplay = this.dataset.autoplay === "true";
      }
      this.container = this.closest(".m-testimonials");
      this.isHomeReviews = this.container && this.container.classList.contains("piri-home-reviews");

      if (!this.design) {
        return console.warn("Failed to init Testimonials: design not found!!");
      }

      this.sliderContainer = this.querySelector(".swiper-container");
      if (!this.sliderContainer) {
        this.classList.add("opacity-100");
        return;
      }

      this.defaultSettings = {
        pagination: {
          el: this.container.querySelector(".swiper-pagination"),
          clickable: true,
        },
        navigation: {
          nextEl: this.container.querySelector(".m-slider-controls__button-next"),
          prevEl: this.container.querySelector(".m-slider-controls__button-prev"),
        },
        autoplay: autoplay
          ? {
              delay: 5000,
              pauseOnMouseEnter: false,
            }
          : false,
        loop: true,
        slidesPerView: 1,
      };

      this.settings = {};
      let gutter = 400;
      switch (this.design) {
        case "testimonials-1":
          this.settings = {
            centeredSlides: true,
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 20,
            speed: 300,
            slideToClickedSlide: true,
            loop: true,
            breakpoints: {
              768: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 20,
                speed: 1000,
              },
              1280: {
                slidesPerView: 5,
                slidesPerGroup: 3,
                spaceBetween: 30,
              },
              2560: {
                slidesPerView: 7,
                slidesPerGroup: 3,
              },
            },
          };
          break;
        case "testimonials-2":
          this.settings = {
            slidesPerView: 1,
            spaceBetween: 30,
            breakpoints: {
              768: { slidesPerView: 3, slidesPerGroup: 3 },
            },
          };
          break;
        case "testimonials-3":
          this.settings = {
            slidesPerView: 1,
            spaceBetween: 30,
            breakpoints: {
              768: { slidesPerView: containerType === "w-full" ? 3 : 2 },
            },
          };
          break;
        case "testimonials-4":
          if (containerType === "container-fluid") gutter = 200;
          if (containerType === "container") gutter = 150;
          this.settings = {
            slidesPerView: 1,
            centeredSlides: true,
            slideToClickedSlide: true,
            breakpoints: {
              768: { spaceBetween: parseInt(gutter / 4), slidesPerView: 3 },
              992: { spaceBetween: gutter / 2, slidesPerView: 3 },
              1920: { spaceBetween: gutter, slidesPerView: 3 },
            },
          };
          break;
        case "testimonials-6":
          this.settings = {
            slidesPerView: 1,
            loop: totalSlides > 3,
            pagination:
              this.dataset.paginationType == "fraction"
                ? {
                    el: this.container.querySelector(".swiper-pagination"),
                    clickable: true,
                    type: "fraction",
                  }
                : {
                    el: this.container.querySelector(".swiper-pagination"),
                    clickable: true,
                  },
            breakpoints: this.isHomeReviews
              ? {
                  768: { slidesPerView: 2 },
                  1280: { slidesPerView: 3 },
                  1600: { slidesPerView: 3 },
                }
              : {
                  768: { slidesPerView: 2 },
                  1366: { slidesPerView: containerType === "container" ? 2 : 3 },
                  1600: { slidesPerView: containerType === "container-fluid" ? 3 : 4 },
                },
          };
          break;
        case "testimonials-7":
          this.settings = {
            slidesPerView: "auto",
            spaceBetween: 16,
            loop: true,
            pagination:
              this.dataset.paginationType == "fraction"
                ? {
                    el: this.container.querySelector(".swiper-pagination"),
                    clickable: true,
                    type: "fraction",
                  }
                : {
                    el: this.container.querySelector(".swiper-pagination"),
                    clickable: true,
                  },
            breakpoints: {
              768: {
                slidesPerView: 2,
                spaceBetween: 24,
              },
              1024: {
                slidesPerView: 2,
                spaceBetween: 30,
              },
            },
          };
          break;
        case "testimonials-8":
          this.settings = {
            fade: {
              crossFade: true,
            },
            pagination:
              this.dataset.paginationType == "fraction"
                ? {
                    el: this.container.querySelector(".swiper-pagination"),
                    clickable: true,
                    type: "fraction",
                  }
                : {
                    el: this.container.querySelector(".swiper-pagination"),
                    clickable: true,
                  },
          };
          break;
        case "testimonials-5":
          this.settings = {
            fade: {
              crossFade: true,
            },
          };
          break;
      }

      // Home reviews: keep the existing cards and palette, animate their depth.
      this.isHomeCarousel = this.isHomeReviews && this.design === "testimonials-6" &&
        document.body.classList.contains("template-index");
      if (this.isHomeCarousel) {
        const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        this.settings = {
          ...this.settings,
          centeredSlides: true,
          slidesPerView: "auto",
          slidesPerGroup: 1,
          spaceBetween: -24,
          speed: reducedMotion ? 0 : 450,
          watchSlidesProgress: true,
          slideToClickedSlide: true,
          grabCursor: totalSlides > 1,
          loop: totalSlides > 1,
          loopedSlides: totalSlides,
          breakpoints: {},
          autoplay: autoplay && !reducedMotion ? {
            delay: 5000,
            pauseOnMouseEnter: true,
            disableOnInteraction: true,
          } : false,
        };
        this.sliderContainer.classList.add("piri-reviews-carousel");
        this.syncHomeReviewsWidth();
      }

      // Testimonials 5
      const images = this.querySelector(".m-tabs");
      if (images) {
        const interval = setInterval(() => {
          if (MinimogTheme.Tabs) {
            clearInterval(interval);
            this.imagesTab = new MinimogTheme.Tabs(images);
          }
        }, 50);
      }

      this.initSlider();
      if (this.isHomeCarousel) {
        this.reviewTextState = new WeakMap();
        this.onReadMoreClick = (event) => {
          const button = event.target.closest(".piri-review-read-more");
          if (!button) return;
          event.preventDefault();
          event.stopPropagation();
          const description = button.closest(".m-testimonial__description");
          const state = this.reviewTextState.get(description);
          state.expanded = !state.expanded;
          this.updateReadMore();
          description.querySelector("button")?.focus({ preventScroll: true });
        };
        this.addEventListener("click", this.onReadMoreClick);
        this.readMoreObserver = new ResizeObserver(() => this.updateReadMore());
        this.readMoreObserver.observe(this.sliderContainer);
        this.updateReadMore();
      }
    }

    updateReadMore() {
      const mobile = window.matchMedia("(max-width: 767px)").matches;
      this.querySelectorAll(".m-testimonial__description").forEach((description) => {
        let state = this.reviewTextState.get(description);
        if (!state) {
          state = { html: description.innerHTML, text: description.textContent.trim().replace(/\s+/g, " "), expanded: false };
          this.reviewTextState.set(description, state);
        }
        const width = description.clientWidth;
        if (state.width === width && state.mobile === mobile && state.lastExpanded === state.expanded) return;
        state.width = width;
        state.mobile = mobile;
        state.lastExpanded = state.expanded;
        description.innerHTML = state.html;
        description.classList.add("piri-review-text-managed");
        const limit = parseFloat(getComputedStyle(description).lineHeight) * (mobile ? 2 : 3) + 1;
        const button = document.createElement("button");
        button.type = "button";
        button.className = "piri-review-read-more";
        button.setAttribute("aria-expanded", String(state.expanded));
        if (state.expanded) {
          button.textContent = "read less";
          description.append(button);
          return;
        }
        if (description.scrollHeight <= limit) return;
        button.textContent = "...read more";
        const text = document.createTextNode("");
        description.replaceChildren(text, button);
        // Fit the link within the line limit, without covering the review text.
        let low = 0, high = state.text.length;
        while (low < high) {
          const middle = Math.ceil((low + high) / 2);
          text.textContent = state.text.slice(0, middle).trimEnd() + " ";
          if (description.scrollHeight <= limit) low = middle;
          else high = middle - 1;
        }
        const excerpt = state.text.slice(0, low);
        const wordEnd = excerpt.lastIndexOf(" ");
        text.textContent = (wordEnd > 0 ? excerpt.slice(0, wordEnd) : excerpt).trimEnd() + " ";
      });
    }

    disconnectedCallback() {
      this.readMoreObserver?.disconnect();
      if (this.onReadMoreClick) this.removeEventListener("click", this.onReadMoreClick);
    }

    syncHomeReviewsWidth() {
      const contentPanel = document.querySelector('[class*="ai-rlt-process-container-"]');
      const reference = contentPanel || document.querySelector(".piri-home-products > .container-fluid, .piri-home-products > .container");
      if (!reference) return;
      const style = getComputedStyle(reference);
      // The adjacent panel's outer border is the visible content boundary.
      // Its internal text padding must not narrow the carousel on smaller screens.
      const width = contentPanel ? reference.getBoundingClientRect().width :
        reference.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
      const container = this.container.firstElementChild;
      container.style.width = `${width}px`;
      container.style.maxWidth = "100%";
    }

    initSlider() {
      this.slider = new MinimogLibs.Swiper(this.sliderContainer, {
        ...this.defaultSettings,
        ...this.settings,
        on: {
          beforeResize: () => {
            if (this.isHomeCarousel) this.syncHomeReviewsWidth();
          },
          setTranslate: (swiper) => {
            if (!this.isHomeCarousel) return;
            swiper.slides.forEach((slide) => {
              const width = slide.swiperSlideSize || slide.offsetWidth;
              const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
              const naturalOffset = slide.swiperSlideOffset + width / 2 + translate - swiper.width / 2;
              const progress = naturalOffset / (width + swiper.params.spaceBetween);
              const distance = Math.abs(progress);
              const scale = 1 / (1 + distance * 0.36);
              // Bring neighbors behind the center card; bound their outer edges
              // to the current container, including while the user drags.
              const card = slide.querySelector(".m-testimonial__wrapper");
              const cardWidth = card ? card.offsetWidth : width;
              const availableOffset = Math.max(0, (swiper.width - cardWidth * scale) / 2);
              const offset = Math.sign(progress) * Math.min(distance, 1) * availableOffset;
              slide.style.transform = `translateX(${offset - naturalOffset}px) scale(${scale})`;
              slide.style.opacity = String(Math.max(0, Math.min(1, (1.5 - distance) * 2)));
              slide.style.pointerEvents = distance < 1.5 ? "" : "none";
              slide.style.zIndex = String(100 - Math.round(distance * 10));
            });
          },
          setTransition: (swiper, duration) => {
            if (!this.isHomeCarousel) return;
            swiper.slides.forEach((slide) => {
              slide.style.transitionDuration = `${duration}ms`;
            });
          },
          init: () => {
            setTimeout(() => {
              window.dispatchEvent(new Event("resize"));
            }, 100);
          },
        },
      });
      if (this.design === "testimonials-4") {
        this.slider.on("activeIndexChange", (swiper) => {
          const { realIndex } = swiper;
          this.querySelector(".m-testimonial-index").innerHTML = parseInt(realIndex) + 1;
        });
      }
      if ((this.design === "testimonials-5") | (this.design === "testimonials-8")) {
        this.slider.on("slideChange", (swiper) => {
          const { realIndex } = swiper;
          this.imagesTab.setActiveTab(realIndex);
        });
      }
      document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
    }

    onBlockSelect(ev) {
      const block = ev.target;
      const index = Number(block.dataset.index);
      if (this.slider) {
        this.slider.slideToLoop(index);
      }
    }
  }

  customElements.define("m-testimonials", MTestimonials);
}
